import React from 'react';
import axios from 'axios';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { ReactComponent as Logo } from './logo.svg';

const Login = ({ setUser }) => (
  <Container
    maxWidth="xs"
    component={Paper}
    variant="outlined"
    style={{ marginTop: 32 }}
  >
    <Box mx="auto" my={4}>
      <Logo />
      <Typography variant="h6">Login</Typography>
      <Formik initialValues={{ email: '', password: '' }}>
        {({
          isSubmitting,
          setSubmitting,
          setFieldError,
          setFieldTouched,
          values,
        }) => (
          <Form>
            <Field
              type="email"
              name="email"
              placeholder="Email address"
              component={TextField}
              fullWidth
              variant="outlined"
              margin="normal"
              required
              autoFocus
            />
            <Field
              type="password"
              name="password"
              placeholder="Password"
              component={TextField}
              fullWidth
              variant="outlined"
              margin="normal"
              required
            />
            <Link
              component={Button}
              to="/signup"
              color="primary"
              style={{ float: 'right', textAlign: 'right' }}
            >
              Don't have an account?
              <br />
              Sign up here
            </Link>
            <Button
              type="submit"
              variant="contained"
              color="secondary"
              disabled={isSubmitting}
              onClick={async () => {
                setSubmitting(true);
                try {
                  const { data } = await axios.post(
                    `${process.env.REACT_APP_API_URL}/user/login`,
                    values,
                  );
                  setUser(data);
                } catch (err) {
                  setFieldTouched('password', true, false);
                  setFieldError(
                    'password',
                    <>
                      {err.response.data.error}{' '}
                      <Link
                        to={`/reset?email=${encodeURIComponent(values.email)}`}
                      >
                        Forgot your password?
                      </Link>
                    </>,
                  );
                }
                setSubmitting(false);
              }}
            >
              Login
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  </Container>
);

export default Login;
